import { useContext, useEffect, useRef, useState } from "react";
import { title } from "../ui/helpers";
import { IconBut } from "../ui/buttons";
import Folders from "./folders";
import { ToggleOverlay } from "./contexts";
import { Decks } from "./flashsets";


const VIEW_NAME = "Library";


export default function Library() {
    const [active, setActive] = useState('decks');

    // useEffect(() => {

    // }, [show])

    return (
        <div id="library" className="view mega-max">
            <div className='content max flex-col'>
                <Header activeLink={active} goTo={goTo} />
                <div style={{ flexGrow: 1 }}>
                    <div className="flex side-scroll max hid-scroll" onScroll={handleScroll}>
                        <Decks name="decks" active={active} />
                        <Folders name="folders" active={active} />
                    </div>
                </div>
            </div>
        </div>
    )

    function handleScroll() {

    }

    function goTo(name) {
        name !== active && setActive(name);
    }

}


function Header({ activeLink, goTo }) {
    const openOverlay = useContext(ToggleOverlay).open;

    return (
        <header className="lib-header fw">
            <div className="flex-col fw pad">
                <div className='flex fw mid-align' style={{ justifyContent: 'space-between' }}>
                    <h3> {VIEW_NAME} </h3>
                    <label className='flex mid-align' style={{ gap: "10px" }}>
                        <IconBut className="fa-solid fa-plus" onClick={createNew} />
                        <div> New </div>
                    </label>
                </div>
                <div className="flex mid-align" style={{ justifyContent: "space-evenly" }}>
                    <NavLink link="flashsets" name="Flashcard sets" goTo={goTo} active={activeLink} />
                    <NavLink link="folders" name="Folders" goTo={goTo} active={activeLink} />
                </div>
            </div>
        </header>
    )


    function createNew() {
        switch (activeLink) {
            case 'flashsets': {
                openOverlay("create-set")
            }
            case 'folders': {
                openOverlay("create-folder")
            }
            case 'quizzes': {
                openOverlay("create-quiz")
            }
            default: {
                console.error("Unexpected Case!!")
            }
        }
    }
}


function NavLink({ active, link, name, goTo }) {

    return (
        <a href={`/library/${link}`} onClick={handleClick} className={`no-link ${active === link ? "active" : ''}`}>
            <div style={{ padding: "5px" }}>
                {title(name)}
            </div>
        </a>
    )

    function handleClick(e) {
        e.preventDefault();

        goTo(link)
    }
}



export function SearchBar({ value, changeSearch }) {

    return (
        <div className="flex" style={{ gap: "10px" }}>
            <label className="fw flex-col">
                <div> Filter by </div>
                <input type="text" placeholder="... Search" value={value} onChange={handleChange} />
            </label>
            <IconBut className="fa-solid fa-xmark" onClick={() => changeSearch('')} />

        </div>
    )

    function handleChange(e) {
        changeSearch(e.target.value)
    }
}